import React from 'react';
import PropTypes from 'prop-types';

const getDisplayName = (entity) =>
    entity.name ||
    entity.title ||
    entity.search_term ||
    entity.username ||
    `ID ${entity.id}`;

const DeleteEntityQuestion = ({ entity }) => (
    <p>
        The following item will be deleted:{' '}
        <strong>{getDisplayName(entity)}</strong>?
    </p>
);

export default DeleteEntityQuestion;

DeleteEntityQuestion.propTypes = {
    entity: PropTypes.object.isRequired,
};
